import TrainingCourseProgressPage from '../TrainingCourses/ProgressPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function CoursePage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('courses.title'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCourseProgressPage isTesting={false} />;
}
